import type { ContextProps, ContextServices } from '../../../types';
import { fetchViewedAndCurrentMember } from '../viewer-controller';
import { handleNavigation, redirectToErrorPage } from './navigation';
import {
  addInitialDataForWidgetPlugins,
  emitMemberChangedEventToPlugins,
} from './widget-plugins';

export const addLoginHandler = (
  contextProps: ContextProps,
  contextServices: ContextServices,
) => {
  return contextProps.wixCodeApi.user.onLogin(async () => {
    try {
      await fetchViewedAndCurrentMember(contextProps, contextServices);
    } catch (error) {
      contextServices.monitoringService.reportError(error as Error);
      return redirectToErrorPage(contextProps, contextServices, error);
    }

    addInitialDataForWidgetPlugins(contextProps, contextServices);
    await emitMemberChangedEventToPlugins(contextProps, contextServices);
    await contextServices.multiStateBoxService.showMainAppState();
    await handleNavigation(contextProps, contextServices);

    return contextServices.menuService.restoreMenuItems(contextProps.state);
  });
};
